import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import authService from './authService'

const initialState = {
  token: null,
  user_info: null,
  order_status: null,
  authLoading: false,
  distribution_status: null,
}

// @desc Get Dsitribution Status
export const getDistributionStatus = createAsyncThunk(
  'distribution_status/get',
  async (token, thunkAPI) => {
    try {
      return await authService.getDistributionStatus(token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
)

export const fetchProfile = createAsyncThunk(
  'profile/get', 
  async (data, thunkAPI) => {
    try {
      return await authService.fetchMyProfile(data)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  }
)

// @desc Get Order
export const getOrderStatus = createAsyncThunk(
  'order_status/get',
  async (token, thunkAPI) => {
    try {
      return await authService.getOrderStatus(token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  }
)

// @desc Get Order
export const getToken = createAsyncThunk(
  'token/get',
  async (data, thunkAPI) => {
    try {
      return await authService.getToken(data)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  }
)

// @desc Logout
export const logout = createAsyncThunk('logout', async (token, thunkAPI) => {
  try {
    return await authService.logout(token)
  } catch (error) {
    return thunkAPI.rejectWithValue(error)
  }
})

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetAuth: (state) => {
      state.token = null
      state.user_info = null
      state.order_status = null
      state.distribution_status = null
    },
    setToken: (state, action) => {
      state.token = action.payload
    },
    resetToken: (state) => {
      state.token = null
    },
    setUserInfo: (state, action) => {
      state.user_info = action.payload
    },
    resetUserInfo: (state) => {
      state.user_info = null
    },
  },
  extraReducers: (builder) => {
    builder
      // GET Distribution Status
      .addCase(getDistributionStatus.pending, (state) => {
        state.distribution_status = null
        state.orderLoading = true
      })
      .addCase(getDistributionStatus.fulfilled, (state, action) => {
        state.distribution_status = action.payload.res.data
        state.orderLoading = false
      })
      .addCase(getDistributionStatus.rejected, (state, action) => {
        state.orderError = action.payload.res
        state.orderLoading = false
      })
      // GET Order Status
      .addCase(getOrderStatus.pending, (state) => {
        state.authLoading = true
      })
      .addCase(getOrderStatus.fulfilled, (state, action) => {
        state.order_status = action.payload
        state.authLoading = false
      })
      .addCase(getOrderStatus.rejected, (state) => {
        state.authLoading = false
      })
      // GET Token
      .addCase(getToken.pending, (state) => {
        state.authLoading = true
      })
      .addCase(getToken.fulfilled, (state, action) => {
        state.token = action.payload
        state.authLoading = false
      })
      .addCase(getToken.rejected, (state) => {
        state.authLoading = false
      })
      // Logout
      .addCase(logout.pending, (state) => {
        state.authLoading = true
      })
      .addCase(logout.fulfilled, (state) => {
        state.authLoading = false
      })
      .addCase(logout.rejected, (state) => {
        state.authLoading = false
      })
  },
})

export const { resetAuth, setToken, resetToken, setUserInfo, resetUserInfo } =
  authSlice.actions

export default authSlice.reducer
